 if (!customElements.get("product-swiper")) {
            class ProductSwiper extends HTMLElement {
                connectedCallback() {
                    const fullWidth = this.dataset.fullWidth === "true";
                    this.swiper = new Swiper(`#${CSS.escape(this.id)} .swiper`,{
                        grabCursor: !0,
                        centeredSlides: !0,
                        slidesPerView: 1.3,
                        spaceBetween: this.dataset.effect === "coverflow" ? 50 : 24,
                        breakpoints: {
                            768: {
                                slidesPerView: 3,
                                spaceBetween: this.dataset.effect === "coverflow" ? 80 : 40
                            },
                            1120: {
                                slidesPerView: 4
                            },
                            1400: {
                                slidesPerView: 5
                            }
                        },
                        loop: !0,
                        loopAdditionalSlides: 5,
                        effect: this.dataset.effect,
                        coverflowEffect: {
                            rotate: 0,
                            stretch: 0,
                            depth: 200,
                            scale: 1,
                            modifier: 1,
                            slideShadows: !1
                        },
                        navigation: {
                            nextEl: `#${CSS.escape(this.id)} .slider-nav__btn[name=next]`,
                            prevEl: `#${CSS.escape(this.id)} .slider-nav__btn[name=prev]`
                        },
                        a11y: {
                            slideRole: null
                        },
                        on: {
                            init: fullWidth ? null : this.updateEdgeSlideVisibility,
                            slideChange: fullWidth ? null : this.updateEdgeSlideVisibility
                        }
                    }),
                    this.swiper.on("init", this.updateSlideTabIndex.bind(this)),
                    this.swiper.on("slideChange", this.updateSlideTabIndex.bind(this))
                }
                updateSlideTabIndex() {
                    this.swiper.slides.forEach( (slide, index) => {
                        const focusableElements = slide.querySelectorAll("product-card, a, button, input, textarea, select, [tabindex]");
                        index === this.swiper.activeIndex ? (slide.removeAttribute("tabindex"),
                        focusableElements.forEach(el => el.removeAttribute("tabindex"))) : (slide.setAttribute("tabindex", "-1"),
                        focusableElements.forEach(el => el.setAttribute("tabindex", "-1")))
                    }
                    )
                }
                updateEdgeSlideVisibility() {
                    this.slides.forEach(slide => slide.classList.remove("is-visible"));
                    const {activeIndex} = this
                      , {slidesPerView} = this.params;
                    let range;
                    slidesPerView <= 1 ? range = 0 : slidesPerView <= 3 ? range = 1 : slidesPerView <= 4 ? range = 2 : range = 3;
                    for (let i = -range; i <= range; i += 1) {
                        const index = (activeIndex + i + this.slides.length) % this.slides.length;
                        this.slides[index].classList.add("is-visible")
                    }
                }
            }
            customElements.define("product-swiper", ProductSwiper)
        }